import { useEffect, useState } from "react";

// True while the app is in dark mode. The theme lives in <body data-theme> (index.tsx and the
// nav drawer's toggle set it), so watch that attribute: things drawn in JS, like chart lines,
// can then re-colour when the theme flips.
const isDark = () => document.body.getAttribute('data-theme') === 'dark';

const useIsDarkTheme = () => {
  const [dark, setDark] = useState(isDark);

  useEffect(() => {
    const observer = new MutationObserver(() => setDark(isDark()));
    observer.observe(document.body, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  return dark;
};

export default useIsDarkTheme;
